import edhec_climateInnov from "./edhec_climateInnov.png";
import edhec_climateInnov_white from "./edhec_climateInnov_white.png";
import climate_innov from "./climate-innov.png";
export const assets = {
  edhec_climateInnov,
  edhec_climateInnov_white,
  climate_innov
};
